import * as React from 'react';

const BikeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bike_svg__eds-icon--bike_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bike_svg__eds-icon--bike_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M18.8 11c-.4 0-.7.1-1.1.1l-2-5.1H18v1h1V5h-5v1h.7l.4 1h-4.7l-.5-1H11V5H8v1h.8l.7 1.7v.1L7 11.4c-.6-.3-1.2-.4-1.8-.4C2.9 11 1 12.8 1 15s2 4 4.2 4 4.2-1.8 4.2-4h1.9l4.4-6.2 1.1 2.7c-1.3.7-2.2 2-2.2 3.5 0 2.2 1.9 4 4.2 4s4.2-1.8 4.2-4-1.9-4-4.2-4zm-3.7-3l-2.8 4-1.6-4h4.4zm-6.6 7c0 1.7-1.5 3-3.2 3S2 16.7 2 15s1.4-3 3.1-3c.4 0 .8.1 1.2.2L4.4 15h4.1zm-.4-1H6.4l.9-1.2c.3.3.6.7.8 1.2zm-.3-2.1l2.2-3 1.7 4.1-.7 1H9.2c-.3-.8-.7-1.5-1.4-2.1zm11 6.1c-1.7 0-3.2-1.3-3.2-3 0-1.1.6-2 1.5-2.6l.9 2.3.9-.4L18 12c.2 0 .5-.1.7-.1 1.7 0 3.2 1.3 3.2 3 .1 1.8-1.3 3.1-3.1 3.1z"
        />
    </svg>
);

BikeSvg.displayName = 'BikeSvg';
export default BikeSvg;
